export class EmptySnakeLayoutNode {
  public readonly kind = 'empty';
}
